<template>
  <div>
    <h2 style="text-align:center;border-bottom:1px solid #000">{{projectData.projectName}}</h2>
    <Form ref="form" :model="form" label-position="left" :label-width="128" :rules="rules" style="margin-top: 30px" :show-message="false">
      <Row>
        <Col span="24">
          <FormItem :labelWidth="80" label="采购方式：" style="margin-bottom: 10px">
            <RadioGroup v-model="buyerModes">
              <Radio :disabled="true" label="公开招标"></Radio>
              <Radio :disabled="true" label="邀请招标"></Radio>
              <Radio :disabled="true" label="竞争性谈判"></Radio>
              <Radio :disabled="true" label="询价"></Radio>
              <Radio :disabled="true" label="单一来源采购"></Radio>
              <Radio :disabled="true" label="竞争性磋商"></Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <p style="margin:0 0 15px 15px;color:red" v-if="showError&&argumentData.purchasingMethod">
        检测到当前招标方式与协议不符，如需更改请点击保存（原招标方式：{{argumentData.purchasingMethod}}）
      </p>
      <!-- 非标准版本显示 -->
      <Row v-if="commissionType !== 'standard' && commissionType !== 'armyYear'">
        <!-- <input-select 
          label="发布采购信息网站：" 
          span="16" 
          v-model="form.publishingURL"
          type="select"
          :options="options.armyWebSource"
          prop="publishingURL">
        </input-select> -->
        <input-select 
          label="发布采购信息网站：" 
          span="16" 
          type="multipleSelect"
          :arrayValue="publishingURL" 
          @arrayChange="(val)=>publishingURL = val"
          :options="options.armyWebSource"
          prop="publishingURL">
        </input-select>
      </Row>
      <!-- 项目基本信息 标准版本才显示 -->
      <div v-if="commissionType == 'standard'">    
        <Row v-if="property === '政府采购'">
          <!-- 单一来源 -->
          <!-- <input-select 
            span="23" 
            :labelWidth="218" 
            label="单一来源：本项目符合以下情形："
            v-model="form.singleSource" 
            type="select"
            rangekey="content"
            :options="options.singleSource"
            v-if="projectData.buyerModes == '单一来源采购'"
            prop="singleSource">
          </input-select> -->
          <!-- 竞争性磋商 -->
          <!-- <input-select 
            span="21" 
            :labelWidth="230" 
            label="竞争性磋商，本项目符合以下情形："
            v-model="form.competitiveNegotiation" 
            type="select" 
            rangekey="content"
            :options="options.competitiveNegotiation"
            v-if="projectData.buyerModes == '竞争性磋商'"
            prop="competitiveNegotiation">
          </input-select> -->
          <input-select span="4" label="项目类别：" :labelWidth="90" type="text" :content="projectData.buyerNature"></input-select>
          <input-select 
            span="8" 
            :labelWidth="1" 
            v-model="form.projectServiceType" 
            type="select" 
            rangekey="content"
            :options="options.projectType"
            v-if="projectData.buyerNature == '服务'"
            :prop="property === '政府采购' ? 'projectServiceType' : ''">
          </input-select>
          <Col span="24" v-if="buyerModes == '公开招标' || buyerModes == '邀请招标'">
            <FormItem label="委托范围：" prop="commissioningScopeOne">
              <span style="margin-right:10px">采用招标方式，组织对投标人的资格审查，资格审查由</span>
              <Radio-group v-model="form.commissioningScopeOne">
                <Radio label="采购人负责"></Radio>
                <Radio label="采购人、采购代理机构共同负责"></Radio>
                <Radio label="采购代理机构负责"></Radio>
              </Radio-group>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="property === '三大主体' || property === '企业采购'">
          <input-select 
            span="14" 
            label="发布采购信息网站(可多选)：" 
            :labelWidth="200"
            :arrayValue="publishingURL" 
            @arrayChange="(val)=>publishingURL = val"
            type="multipleSelect" 
            :options="options.media"
            :prop="property === '三大主体' || property === '企业采购' ? 'publishingURL' : ''">
          </input-select>
          <Col span="9" :offset="1" v-show="form.publishingURL.indexOf('其他') != -1">
            <input-select 
              span="18" 
              :labelWidth="1" 
              v-model="form.otherURL" 
              :prop="form.publishingURL.indexOf('其他') != -1 ? 'otherURL' : ''" 
              placeholder="请在此处输入其他网址">
            </input-select>
          </Col>
        </Row>
        <Row v-if="property === '三大主体'">
          <input-select 
            span="21" 
            label="资金来源：" 
            v-model="form.fundsSource" 
            type="select" 
            :options="options.source" 
            :prop="property === '三大主体' ? 'fundsSource' : ''">
          </input-select>
        </Row>
        <Row v-if="property === '国际标'">
          <input-select 
            span="6" 
            label="招标人类型：" 
            v-model="form.tendereeType" 
            type="select" 
            :options="options.bidderType" 
            :prop="property === '国际标' ? 'tendereeType' : ''">
          </input-select>
          <Col span="4" :offset="1" v-if="form.tendereeType == '其他'">
            <input-select span="24" :labelWidth="1" v-model="tendereeType" placeholder="请输入招标人类型"></input-select>
          </Col>
          <input-select 
            span="9" 
            label="资金来源：" 
            v-model="form.fundsSource" 
            type="select" 
            :options="options.interSource" 
            :prop="property === '国际标' ? 'fundsSource' : ''">
          </input-select>
          <input-select 
            span="14" 
            label="国际招标法定媒体(可多选)：" 
            :labelWidth="180"
            :arrayValue="publishingURL" 
            @arrayChange="(val)=>publishingURL = val"
            type="multipleSelect"
            :options="options.interMedia" 
            :prop="property === '国际标' ? 'publishingURL' : ''">
          </input-select>
          <Col span="9" :offset="1">
            <input-select 
              span="18" 
              :labelWidth="1" 
              v-model="form.otherURL" 
              prop="otherURL" 
              placeholder="请在此处输入其他网址"
              v-if="form.publishingURL.indexOf('其他') != -1">
            </input-select>
          </Col>
        </Row>
        <!-- <Row v-if="property === '政府采购'">
          
        </Row> -->
      </div>
      <!-- 责任和义务 -->
      <div>
        <h3 style="text-align:center;margin: 10px 0">{{partyA}}和{{partyB}}的责任和义务</h3>
        <h3>（一）{{partyA}}的责任和义务</h3>
        <p style="text-indent:15px;margin: 6px 0" v-if="property !== '国际标'">
          积极配合乙方开展采购工作，指定一位本单位工作人员作为甲方的项目联系人，代表甲方负责联系和处理采购过程中的有关具体事项。
        </p>
        <p style="text-indent:15px;margin: 6px 0" v-else>
          与受托人共同商定招标程序，并密切配合受托人进行招标活动，积极配合招标代理机构开展招标工作，指定一位本单位工作人员作为委托人的项目负责人，代表委托人负责联系和处理招标过程中的有关具体事项；指定人员如有变更应书面知会受托人。
        </p>
        <Row>
          <input-select span="7" label="指定人员姓名：" v-model="form.partyAContact" prop="partyAContact"></input-select>
          <input-select span="7" label="联系电话：" :labelWidth="90" v-model="form.partyAContactNumber" prop="partyAContactNumber"></input-select>
          <input-select span="7" label="Email：" :labelWidth="90" v-model="form.partyAEmail" prop="partyAEmail"></input-select>
          <!-- 军工 显示身份证 -->
          <div v-if="commissionType !== 'standard'">
            <input-select span="7" label="身份证号码：" v-model="form.partyAIDNumber" prop="partyAIDNumber"></input-select>
          </div>
        </Row>
        <!-- 政府采购 -->
        <div v-if="property === '政府采购'" style="color:#f30;display:flex;align-items:center;margin:0 0 8px 10px">
          <span>（甲方同意上述的指定项目联系人</span>
          <Select v-model="form.ifKnow" style="width:100px;margin:0 5px">
            <Option value="可以获悉" key="可以获悉">可以获悉</Option>
            <Option value="不能获悉" key="不能获悉">不能获悉</Option>
          </Select>
          <span>本项目已获取采购文件的潜在投标人的名称、数量情况。如可以获悉，乙方需按照上述E-mai1地址告知。）</span>
        </div>
        <Row v-if="property === '国际标' && commissionType == 'standard'">
          <input-select 
            label="委托人要求受托人在招标文件中明确最高投标限价："
            :labelWidth="300" 
            span="9" 
            v-model="form.maxBidLimit" 
            prop="maxBidLimit"
            v-if="property === '国际标'">
          </input-select>
          <span style="line-height:32px">（单位：元）</span>
        </Row>
        <Row v-if="commissionType == 'armySingle'">
          <p style="text-indent:15px;margin: 6px 0">
            确定本项目参与评审会议的评审专家组成及抽取方式，参与本次采购项目的评审专家共 {{ expertsTotal }} 名，其中：
          </p>
          <input-select label="甲方委派代表" :labelWidth="108" span="4" v-model="form.partyACount" prop="partyACount"></input-select>
          <input-select label="名；军队专家" :labelWidth="108" span="4" v-model="form.militaryExpertCount" prop="militaryExpertCount"></input-select>
          <input-select label="名；在" :labelWidth="70" span="4" v-model="form.militaryExpertLocation" prop="militaryExpertLocation"></input-select>
          <input-select label="抽取；地方专家" :labelWidth="118" span="4" v-model="form.localExpertCount" prop="localExpertCount"></input-select>
          <input-select label="名；在" :labelWidth="70" span="4" v-model="form.locationExpertLocation" prop="locationExpertLocation"></input-select>
          <span style="line-height:32px;margin-left: 10px">抽取</span>
        </Row>
        <div v-if="commissionType == 'standard'">
          <Row style="margin-top: 10px" v-if="property === '企业采购'">
            <p style="text-indent:15px">确定以下列方式按照规定抽取评审专家：</p>
            <Col span="18">
              <FormItem label="专家抽取方式：" :prop="property === '企业采购' ? 'expertExtractionMethod' : ''">
                <Card>
                  <p slot="title">
                    <RadioGroup v-model="expertExtractionMethod">
                      <Radio :label="item.remark" v-for="item in options.expertExtractionMethod" :key="item.id"></Radio>
                      <Radio label="其他"></Radio>
                    </RadioGroup>
                  </p>
                  <Input v-model="form.expertExtractionMethod" type="textarea" :autosize="true" placeholder="请在此处填入专家抽取方式"></Input>
                </Card>
              </FormItem>
            </Col>
          </Row>
        </div>
        <h3>（二）{{partyB}}的责任和义务</h3>
        <p style="text-indent:15px;margin: 6px 0">指定两名本单位工作人员：一名项目负责人代表乙方负责项目统筹和指导工作；一名经办人代表乙方联系和处理采购项目过程中的有关具体事项。</p>
        <!-- 项目负责人 -->
        <Row>
          <input-select span="7" label="项目负责人姓名：" v-model="form.partyBContact" prop="partyBContact"></input-select>
          <input-select span="7" label="联系电话：" :labelWidth="90" v-model="form.partyBContactNumber" prop="partyBContactNumber"></input-select>
          <input-select span="7" label="Email：" :labelWidth="90" v-model="form.partyBEmail" prop="partyBEmail"></input-select>
          <!-- 军工 显示身份证 -->
          <div v-if="commissionType !== 'standard'">
            <input-select span="7" label="身份证号码：" v-model="form.partyBIDNumber" prop="partyBIDNumber"></input-select>
          </div>
        </Row>
        <!-- 项目经办人 -->
        <Row>
          <input-select span="7" label="项目经办人姓名：" v-model="form.agentContact" prop="agentContact"></input-select>
          <!-- <input-select span="7" label="项目负责人姓名：" prop="principalContact" type="select" :options="options.principals" v-model="principalSelect" @onChange="(val) => principalSelect = val"></input-select> -->
          <input-select span="7" label="联系电话：" :labelWidth="90" v-model="form.agentContactNumber" prop="agentContactNumber"></input-select>
          <input-select span="7" label="Email：" :labelWidth="90" v-model="form.agentEmail" prop="agentEmail"></input-select>
          <!-- 军工 显示身份证 -->
          <div v-if="commissionType !== 'standard'">
            <input-select span="7" label="身份证号码：" v-model="form.agentIDNumber" prop="agentIDNumber"></input-select>
          </div>
        </Row>
        <Row>
          <div v-if="commissionType !== 'standard'">
            <input-select
              v-if="commissionType !== 'armySingle'"
              span="7"
              label="委托期限："
              :labelWidth="90"
              prop="commissionBeginDate"
              v-model="form.commissionBeginDate"
              type="date">
            </input-select>
            <input-select
              v-if="commissionType !== 'armySingle'"
              span="7"
              label="至"
              :labelWidth="90"
              prop="commissionEndDate"
              v-model="form.commissionEndDate"
              type="date">
            </input-select>
          </div>
        </Row>
        <div style="text-indent:15px;margin: 6px 0">
          <div>项目负责人选择说明：</div>
          <div style="text-indent:30px;margin-top:6px">1、广东省内：一般情况下选择“梁群燕”。如该客户以往有项目负责人（仍在职）且不是“梁群燕”，则选择以往的项目负责人。</div>
          <div style="text-indent:30px;">2、广东省外：一般情况下选择“刘泽烨”。如该客户以往有项目负责人（仍在职）且不是“刘泽烨”，则选择以往的项目负责人。</div>
        </div>
        <div style="text-indent:15px;margin: 6px 0">
          项目经办人选择说明：项目经办人请填写该项目的客户经理
        </div>
      </div>
      <!-- 收费  争议解决与违约责任 其他-->
      <div v-if="commissionType == 'standard'">     <!-- 标准版本才显示-->
        <h3 style="text-align:center;margin: 10px 0">收 费</h3>
        <Row v-if="property !== '政府采购'">
          <Col span="23">
            <FormItem label="请选择收费方式：" prop="chargingMethodOne">
              <Card>
                <p slot="title">
                  <RadioGroup v-model="chargingMethod">
                    <Radio :label="item.remark" v-for="item in options.chargingMethod" :key="item.id"></Radio>
                  </RadioGroup>
                </p>
                <Input v-model="form.chargingMethodOne" type="textarea" :autosize="true" placeholder="请在此处填入收费方式"></Input>
              </Card>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="property === '政府采购'">
          <Col span="23">
            <FormItem label="请选择收费方式：" :prop="property==='政府采购'?'drawee':'chargingMethodOne'">
              <div v-if="property === '政府采购'">
                乙方向
                <Select v-model="form.drawee" style="width:120px">
                  <Option v-for="item in ['中标、成交人','采购人']" :value="item" :key="item">{{ item }}</Option>
                </Select>
                收取采购代理服务费用。
              </div>
            </FormItem>
          </Col>
          <Col span="15">
            <FormItem :labelWidth="380" label="项目废标后，委托乙方重新组织采购活动，则按上述收费标准上浮" prop="floatingRate">
              <InputNumber v-model="form.floatingRate" style="width:80px"></InputNumber> %后收取代理服务费。
            </FormItem>
          </Col>
          <Col span="8" style="line-height:30px">
            <Checkbox v-model="form.isShowFloatingRate">是否显示此项（勾选此项则显示，否则隐藏）</Checkbox>
          </Col>
          <Col span="23">
            <FormItem :labelWidth="260" label="采购项目废标，不同情形按以下原则计付：">
              <Input v-model="form.otherChargeInfo" type="textarea" :autosize="true"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="property === '国际标'">
          <Col span="23">
            <FormItem label="其他收费说明：" :prop="property === '国际标' ? 'otherChargeInfo' : ''">
              <Card>
                <p slot="title">
                  <RadioGroup v-model="otherChargeInfo">
                    <Radio :label="item.remark" v-for="item in options.otherChargeInfo" :key="item.id"></Radio>
                  </RadioGroup>
                </p>
                <Input v-model="form.otherChargeInfo" type="textarea" :autosize="true"></Input>
              </Card>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="property === '企业采购'">
          <Col span="23">
            <FormItem :labelWidth="15" :prop="property === '企业采购' ? 'isRejection' : ''">
              <span>若项目废标，采购招标代理服务费按以下原则计付：</span>
              <RadioGroup v-model="form.isRejection">
                <Radio style="margin-left: 20px" label="是"></Radio>
                <Radio style="margin-left: 20px" label="否"></Radio>
              </RadioGroup>
              <span>(选择是则显示本项，否则不显示)</span>
            </FormItem>
            <Card v-if="form.isRejection == '是'">
              <Row>
                <Col span="19" style="line-height:32px">（1） 项目发布采购公告后因投标人报名家数不足法定数量要求导致该项目废标，则由甲方按第1点所述收费标准的</Col>
                <input-select span="2" :labelWidth="1" v-model="form.chargingStandardOne" prop="chargingStandardOne"></input-select>
                <Col span="3" style="line-height:32px">向乙方计付；</Col>
              </Row>
              <Row>
                <Col span="17" style="line-height:32px">（2） 评标过程中因合格投标人家数不足法定要求而导致项目废标的，由甲方按第1点所述收费标准的</Col>
                <input-select span="2" :labelWidth="1" v-model="form.chargingStandardTwo" prop="chargingStandardTwo"></input-select>
                <Col span="3" style="line-height:32px">向乙方计付；</Col>
              </Row>
              <Row>
                <Col span="15" style="line-height:32px">（3） 项目如出现二次或以上废标的，从第二次废标起，则由甲方按第1点所述收费标准的</Col>
                <input-select span="2" :labelWidth="1" v-model="form.chargingStandardThree" prop="chargingStandardThree"></input-select>
                <Col span="3" style="line-height:32px">向乙方计付；</Col>
              </Row>
              <Row>
                （4） 评标过程中出现项目废标的情形但在征得甲方书面同意的情况下于评标现场通过改变采购方式而顺利完成项目采购的，则由乙方按第1点所述收费标准收取；
              </Row>
              <Row>
                （5） 项目发出中标通知书前，由于中标（成交）候选人放弃中标（成交）资格而甲方根据项目情况不再推荐第二中标（成交）候选人为项目中标人的，没收放弃中标（成交）资格的中标（成交）候选人所交纳的投标保证金，受托方的采购招标代理服务费则从没收的投标保证金进行扣取；如需受托方再次组织招标的，采购招标代理服务费仍按照第1条收费标准收取。
              </Row>
              <Row>
                <Col span="19" style="line-height:32px">（6） 项目发出中标通知书前，中标（成交）候选人被取消中标（成交）资格的，由甲方按第1点所述收费标准的</Col>
                <input-select span="2" :labelWidth="1" v-model="form.chargingStandardFour" prop="chargingStandardFour"></input-select>
                <Col span="3" style="line-height:32px">向乙方计付；</Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <h3 style="text-align:center;margin: 10px 0">争议解决与违约责任</h3>
        <Row style="margin-left: 15px"  v-if="property !== '政府采购'">
          <Col span="23">
            <FormItem :labelWidth="1" prop="defaultMethod">
              <p>因履行本协议所发生的争议或纠纷，双方应通过友好协商解决，协商不成的，双方同意按以下方式：</p>
              <RadioGroup v-model="form.defaultMethod">
                <Radio :label="item.content" v-for="item in options.defaultMethod" :key="item.id"></Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row style="margin-left: 15px"  v-if="property === '政府采购'">
          <Col span="23">
            <FormItem :labelWidth="1" prop="defaultMethod">
              <p>因履行本协议所发生的争议或纠纷，双方应通过友好协商解决，协商不成的，双方同意按下列第
                <Select v-model="form.defaultMethod" style="width:60px" placeholder="">
                  <Option v-for="item in options.solution" :value="item.label" :key="item.label">{{ item.label }}</Option>
                </Select>
                种方式解决：
              </p>
              <p v-for="(item,index) in options.solution" :key="item.label">
                {{index+1}}）{{item.value}}
              </p>
            </FormItem>
          </Col>
        </Row>
        <h3 style="text-align:center;margin: 10px 0">其他</h3>
        <Row>
          <input-select label="本协议正本" :labelWidth="100" span="4" v-model="form.num1" prop="num1"></input-select>
          <input-select label="式" :labelWidth="58" span="3" v-model="form.num2" prop="num2"></input-select>
          <input-select label="份，甲方、乙方各执" :labelWidth="146" span="5" v-model="form.num3" prop="num3"></input-select>
          <span style="line-height:32px;margin-left: 10px">份，具有同等法律效力。</span>
        </Row>
        <h3 style="text-align:center;margin: 10px 0">合同订立</h3>
        <Row>
          <FormItem :labelWidth="1" prop="contractDate">
            <span style="margin-left: 15px">1、合同订立时间：</span>
            <DatePicker :value="form.contractDate" format="yyyy年MM月dd日" type="date" @on-change="(e)=>{form.contractDate=e}">
            </DatePicker>
          </FormItem>
        </Row>
        <Row style="margin-left:15px">2、合同生效时间：自双方盖章之日起生效。</Row>
      </div>
    </Form>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import inputSelect from '@/components/inputSelect'
import axios from 'axios'

export default {
  props: {
    projectData: Object,
    argumentData: Object,
    commissionType: {
      type: String,
      default: 'standard'
    }
  },
  components: {
    inputSelect
  },
  data() {
    const validate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('不能为空'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        singleSource: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],    // 单一来源
        competitiveNegotiation: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],   // 竞争性磋商
        partyAContact: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],    // 甲方联系人
        partyAContactNumber: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],   // 甲方联系电话
        // partyAEmail: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        //   { type: 'email', message: '格式不正确', trigger: 'blur' }
        // ],    // 甲方email
        agentContact: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],    // 乙方负责人联系人
        agentContactNumber: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],   // 乙方负责人联系电话
        partyBContact: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],    // 乙方联系人
        partyBContactNumber: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],   // 乙方联系电话
        // partyBEmail: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        //   { type: 'email', message: '格式不正确', trigger: 'blur' }
        // ],    // 乙方email
        chargingMethodOne: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],    // 收费方式 1
        defaultMethod: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],    // 违约采取方式
        num1: [
          { validator: validate, trigger: 'blur' }
        ],
        num2: [
          { validator: validate, trigger: 'blur' }
        ],
        num3: [
          { validator: validate, trigger: 'blur' }
        ],
        commissioningScopeOne: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 委托范围1
        expertExtractionMethod: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 专家抽取方式
        publishingURL: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 发布网址
        chargingStandardOne: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 废标收费标准1
        chargingStandardTwo: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 废标收费标准2
        chargingStandardThree: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 废标收费标准3
        chargingStandardFour: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 废标收费标准4
        fundsSource: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 资金来源
        tendereeType: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 招标人类型
        maxBidLimit: [
          { validator:  validate, trigger: 'blur' }
        ],  // 最高投标限价
        isRejection: [
          { validator: validate, trigger: 'blur' }
        ],  // 是否废标
        otherURL: [
          { validator: validate, trigger: 'blur' }
        ],  // 其他网址
        projectServiceType: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 项目服务类别
        otherChargeInfo: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 其他收费说明
        procurementFund: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 采购资金
        // partyAIDNumber: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],  // 甲方身份证号码
        // partyBIDNumber: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],  // 乙方身份证号码
        expertCount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 评审专家人数
        militaryExpertCount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 军队专家人数
        localExpertCount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 地方专家人数
        partyACount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 甲方代表人数
        militaryExpertLocation: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 军队专家抽取地点
        locationExpertLocation: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 地方专家抽取地点
        commissionBeginDate: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],  // 委托开始时间
        commissionEndDate: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],   // 委托结束时间
        drawee: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],   // 付款人
        // floatingRate: [
        //   { required: true, message: '不能为空', trigger: 'blur', type: 'number' }
        // ],   // 上浮率
        contractDate: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]   // 合同日期
      },
      form: {
        projectId: "",
        singleSource: "",    // 单一来源
        competitiveNegotiation: "",   // 竞争性磋商
        partyAContact: "",    // 甲方联系人
        partyAContactNumber: "",   // 甲方联系电话
        partyAEmail: "",    // 甲方email
        agentContact: "",    // 乙方经办人联系人
        agentContactNumber: "",   // 乙方经办人联系电话
        agentEmail: "",    // 乙方经办人email
        partyBContact: "",    // 乙方联系人
        partyBContactNumber: "",   // 乙方联系电话
        partyBEmail: "",    // 乙方email
        chargingMethodOne: "",    // 收费方式 1
        // chargingMethodTwo: "",    // 收费方式 2
        // chargingMethodThree: "",  // 收费方式 3
        // chargingMethodFour: "",   // 收费方式 4
        // chargingMethodFive: "",   // 收费方式 5
        defaultMethod: "",    // 违约采取方式
        num1: "",
        num2: "",
        num3: "",
        purchasingMethod: "",   //采购方式
        commissioningScopeOne: "",  // 委托范围1
        // commissioningScopeTwo: "",  // 委托范围2
        projectNumber: "",   // 项目编号? (projectNum)
        projectNum: "",
        expertExtractionMethod: "",  // 专家抽取方式
        publishingURL: "",  // 发布网址
        chargingStandardOne: "",  // 废标收费标准1
        chargingStandardTwo: "",  // 废标收费标准2
        chargingStandardThree: "",  // 废标收费标准3
        chargingStandardFour: "",  // 废标收费标准4
        fundsSource: "",  // 资金来源
        tendereeType: "",  // 招标人类型
        maxBidLimit: "",  // 最高投标限价
        otherURL: "",    // 其他网址
        isRejection: "",  // 是否废标
        projectServiceType: "",  // 项目服务类别
        otherChargeInfo: "",  // 其他收费说明
        // procurementFund: "",  // 采购资金
        partyAIDNumber: "",  // 甲方身份证号码
        partyBIDNumber: "",  // 乙方身份证号码
        agentIDNumber: '', // 乙方负责人身份证号码
        expertCount: "",  // 评审专家人数
        militaryExpertCount: "",  // 军队专家人数
        localExpertCount: "",  // 地方专家人数
        partyACount: "",  // 甲方代表人数
        militaryExpertLocation: "",  // 军队专家抽取地点
        locationExpertLocation: "",  // 地方专家抽取地点
        commissionBeginDate: "",  // 委托开始时间
        commissionEndDate: "",   // 委托结束时间
        drawee: "",       // 付款人
        floatingRate: "",     //  上浮率
        contractDate: "",     //  合同订立时间
        isShowFloatingRate: true
      },
      options: {
        projectType: [],
        source: [
          {
            label: '单位自有资金，未纳入预算管理的资金（不纳入政府采购管理范围）',
            value: '单位自有资金，未纳入预算管理的资金（不纳入政府采购管理范围）'
          },
          {
            label: '使用财政性资金，但本项目采购内容不在集中采购目录以内或采购限额标准以下( 不纳入政府采购管理范围 )',
            value: '使用财政性资金，但本项目采购内容不在集中采购目录以内或采购限额标准以下( 不纳入政府采购管理范围 )'
          }
        ],
        interSource: [
          {
            label: '现汇项目',
            value: '现汇项目'
          },
          {
            label: '世行',
            value: '世行'
          },
          {
            label: '亚行',
            value: '亚行'
          },
          {
            label: '日贷',
            value: '日贷'
          },
          {
            label: '外国政府贷款',
            value: '外国政府贷款'
          }
        ],
        bidderType: [
          {
            label: '国家机关',
            value: '国家机关'
          },
          {
            label: '事业单位',
            value: '事业单位'
          },
          {
            label: '团体组织',
            value: '团体组织'
          },
          {
            label: '其他',
            value: '其他'
          },
        ],
        media: [
          {
            label: '中国政府采购网(www.ccgp.gov.cn)',
            value: '中国政府采购网(www.ccgp.gov.cn)'
          },
          {
            label: '中国采购与招标网(http://www.chinabidding.com.cn)',
            value: '中国采购与招标网(http://www.chinabidding.com.cn)'
          },
          {
            label: '采购代理机构网站(www.chinapsp.cn)',
            value: '采购代理机构网站(www.chinapsp.cn)'
          },
          {
            label: '其他',
            value: '其他'
          },
        ],
        armyWebSource: [
          {
            label: '全军武器装备采购信息网(http://www.weain.mil.cn/)',
            value: '全军武器装备采购信息网(http://www.weain.mil.cn/)'
          },
          {
            label: '军队采购网(https://www.plap.cn/)',
            value: '军队采购网(https://www.plap.cn/)'
          },
          {
            label: '中国招标投标公共服务平台(http://www.cebpubservice.com/)',
            value: '中国招标投标公共服务平台(http://www.cebpubservice.com/)'
          },
          {
            label: '中国政府采购网(www.ccgp.gov.cn)',
            value: '中国政府采购网(www.ccgp.gov.cn)'
          },
          {
            label: '其他',
            value: '其他'
          }
        ],
        interMedia: [
          {
            label: '中国国际招标网（http://www.chinabidding.com/）',
            value: '中国国际招标网（http://www.chinabidding.com/）'
          },
          {
            label: '中国招标公共服务平台（http://www.cebpubservice.com/）',
            value: '中国招标公共服务平台（http://www.cebpubservice.com/）'
          },
          {
            label: '中国采购与招标网（http://www.chinabidding.com.cn/）',
            value: '中国采购与招标网（http://www.chinabidding.com.cn/）'
          },
          {
            label: '招标代理机构网（http://www.chinapsp.cn/）',
            value: '招标代理机构网（http://www.chinapsp.cn/）'
          },
          {
            label: '其他',
            value: '其他'
          },
        ],
        chargingMethod: [],
        otherChargeInfo: [],
        defaultMethod: [],
        expertExtractionMethod: [],
        competitiveNegotiation: [],
        singleSource: [],
        solution: [
          {
            label: '1',
            value: '双方达成仲裁协议，向广州仲裁委员会申请仲裁，并按该委现行仲裁规则予以仲裁；'
          },
          {
            label: '2',
            value: '依法向广州市人民法院提起起诉。'
          }
        ],
        principals: [
          {
            label: '梁群燕',
            value: '梁群燕',
            email: 'liangqunyan@choicelink.cn',
            phone: '13910926103'
          },
          {
            label: '刘泽烨',
            value: '刘泽烨',
            email: 'liuzeye@chinapsp.cn',
            phone: '19102023881'
          },
          {
            label: '黎健明',
            value: '黎健明',
            email: 'lijianming@chinapsp.cn',
            phone: '18926414508'
          },
          {
            label: '邱晓洁',
            value: '邱晓洁',
            email: 'qiuxiaojie@chinapsp.cn',
            phone: '19102023820'
          },
        ]
      },
      partyA: '甲方',
      partyB: '乙方',
      tendereeType: '',
      publishingURL: [],
      principalSelect: [],
      expertExtractionMethod: '',
      chargingMethod: '',
      otherChargeInfo: '',
    }
  },
  computed: {
    expertsTotal() {
      let partyACount = this.form.partyACount == '' ? 0 : this.form.partyACount
      let militaryExpertCount = this.form.militaryExpertCount == '' ? 0 : this.form.militaryExpertCount
      let localExpertCount = this.form.localExpertCount == '' ? 0 : this.form.localExpertCount
      return parseInt(partyACount) + parseInt(militaryExpertCount) + parseInt(localExpertCount)
    },
    property() {
      return this.projectData.projectProperty
    },
    buyerModes() {
      this.form.purchasingMethod = this.projectData.buyerModes
      return this.projectData.buyerModes
    },
    length() {
      return this.options.otherChargeInfo.length
    },
    showError() {
      return this.argumentData.purchasingMethod !== this.projectData.buyerModes
    }
  },
  watch: {
    argumentData(val) {
      this.form = Object.assign({}, val)
      this.publishingURL = val.publishingURL ? val.publishingURL.split(',') : []
      // 招标方式更改
      if (val.purchasingMethod !== this.projectData.buyerModes) {
        this.form.purchasingMethod = this.projectData.buyerModes
      }
    },
    projectData(val) {
      this.partyA = val.projectProperty == '国际标' ? '委托人' : '甲方'
      this.partyB = val.projectProperty == '国际标' ? '受托人' : '乙方'
      this.form.projectId = val.id
      this.form.projectNumber = val.projectFull
      this.form.projectNum = val.projectFull
      // 获取收费方式选项信息
      let classification
      switch(val.projectProperty) {
        case '三大主体': classification = 7
          break
        case '政府采购': classification = 1
          // 单一来源采购
          this.getOptionLists(2).then(res => {
            this.options.singleSource = res.data.result.items
          })
          // 竞争性磋商
          this.getOptionLists(3).then(res => {
            this.options.competitiveNegotiation = res.data.result.items
          })
          // 项目类别
          this.getOptionLists(9).then(res => {
            let data = res.data.result.items.sort((a, b) => a.remark.localeCompare(b.remark))  // 排序
            this.options.projectType = data
          })
          // 其他收费说明（政府采购）
          this.getOptionLists(10).then(res => {
            let data = res.data.result.items.sort((a, b) => a.remark.localeCompare(b.remark))  // 排序
            this.options.otherChargeInfo = data
          })
          break
        case '企业采购': classification = 6
        // 专家抽取方式
        this.getOptionLists(5).then(res => {
          let data = res.data.result.items.sort((a, b) => a.remark.localeCompare(b.remark))  // 排序
          this.options.expertExtractionMethod = data
        })
          break
        case '国际标': classification = 8
          break
      }
      // 收费方式
      this.getOptionLists(classification).then(res => {
        let data = res.data.result.items.sort((a, b) => a.remark.localeCompare(b.remark))  // 排序
        // 国际标 收费方式会返回其他说明
        this.options.chargingMethod = data.filter(item => item.remark.indexOf('收费方式') != -1)
        if (classification === 8) {
          this.options.otherChargeInfo = data.filter(item => item.remark.indexOf('其他说明') != -1)
        }
      })
      // 违约采取方式
      this.getOptionLists(4).then(res => {
        let data = res.data.result.items.sort((a, b) => a.remark.localeCompare(b.remark))  // 排序
        this.options.defaultMethod = data
      })
    },
    publishingURL(val) {
      this.form.publishingURL = ''
      val.forEach(item => {
        this.form.publishingURL += `${item},`
      })
      this.form.publishingURL = this.form.publishingURL.slice(0,-1)
    },
    principalSelect(val) {
      console.log(val)
      this.form.agentContact = ''
      this.form.agentContactNumber = ''
      this.form.agentEmail = ''
      if (val !== '其他') {
        const principal = this.options.principals.filter(item => item.value === val)[0]
        console.log(princlpal)
        this.form.agentContact = principal.value
        this.form.agentContactNumber = principal.phone
        this.form.agentEmail = principal.email
      }
    },
    expertExtractionMethod(val) {
      if (val == '其他') {
        this.form.expertExtractionMethod = ``
        return
      }
      let arr = this.options.expertExtractionMethod.filter(item => item.remark == val)
      this.form.expertExtractionMethod = arr[0].content
    },
    chargingMethod(val) {
      let arr = this.options.chargingMethod.filter(item => item.remark == val)
      this.form.chargingMethodOne = arr[0].content
    },
    otherChargeInfo(val) {
      let arr = this.options.otherChargeInfo.filter(item => item.remark == val)
      this.form.otherChargeInfo = arr[0].content
    },
    length(val) {
      if(this.property == '政府采购') {
        this.form.otherChargeInfo = this.options.otherChargeInfo[0].content
      }
    }
  },
  methods: {
    async getOptionLists(classification) {
      let rep = await axios.get('https://www.choicelink.cn:8444/cailian/GetOptionList', {
        params: {
          filter: `classification == "${classification}"`
        }
      })
      return rep
    },
    save() {
      // 检验手机号
      if (this.form.ifKnow === '可以获悉' && !(/^1[3456789]\d{9}$/.test(this.form.partyAContactNumber))) {
        this.$Message.error('甲方联系方式需填写手机号！')
        return
      }
      this.$refs.form.validate((valid,e) => {
        if (valid) {
          if (this.form.tendereeType == '其他') {
            if (this.tendereeType == '') {
              this.$Message.error('请输入其他招标人类型！')
              return
            }
            this.form.tendereeType = `其他：${this.tendereeType}`
          }
          this.form.expertCount = this.expertsTotal   // 评审专家人数
          this.form = Object.assign(this.form,{
            projectId: this.projectData.id,
            projectNumber: this.projectData.projectFull,
            projectNum: this.projectData.projectFull,
          })
          // ajax.post(requestUrls.CLTrustAgreementInfo.CreateOrUpdate, {
          //   clTrustAgreementInfo: this.form
          // }).then(res => {
          //   this.$Message.success('保存成功！')
          //   this.$emit('visible')
          //   this.$refs.form.resetFields()   // 重置表单
          // })
          axios.post('https://www.choicelink.cn:8444/cailian/CreateTrustAgreementOrUpdate', {
            clTrustAgreementInfo: this.form
          }).then(res => {
            this.$Message.success('保存成功！')
            this.$emit('visible')
            this.$refs.form.resetFields()   // 重置表单
          })
        } else {
          this.$Message.error('请完善信息填写！')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ivu-form-item {
  // margin-bottom: 10px;
  .ivu-form-item-label {
    padding-left: 15px !important;
    white-space: nowrap;
  }
}
</style>